import * as React from 'react';

import { IconProps } from 'bones/design-system/components/icons/Icon';

export type PortalLogoProps = {
  title?: string;
} & IconProps &
  React.SVGProps<SVGSVGElement>;

export const PortalLogo: React.VFC<PortalLogoProps> = ({
  size,
  title,
  ...props
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 28 29"
    width={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M16.1566 18.574L17.4837 18.0349L18.6139 18.7717C21.3635 19.0754 24.0328 19.6465 26.5947 20.4588C27.3379 18.7674 27.7512 16.8983 27.7512 14.9324C27.7512 7.33784 21.5947 1.1814 14.0001 1.1814C6.4055 1.1814 0.249023 7.33856 0.249023 14.9332C0.249023 16.899 0.662253 18.7682 1.4055 20.4595C5.37847 19.1992 9.61033 18.5192 14.0001 18.5192C14.7234 18.5185 15.4425 18.5377 16.1566 18.574Z"
      fill="#003346"
    />
    <path
      d="M25.1249 23.0165C25.7017 22.2242 26.1961 21.3672 26.5951 20.4596C24.0332 19.6467 21.3639 19.0756 18.6143 18.7726L25.1249 23.0165Z"
      fill="#007FA4"
    />
    <path
      d="M11.9425 28.5315L6.865 22.3473L16.1573 18.5742C15.4432 18.5379 14.7242 18.5187 14.0008 18.5187C9.61037 18.5187 5.37922 19.1986 1.40625 20.4589C3.26898 24.7008 7.21066 27.821 11.9425 28.5315Z"
      fill="#007FA4"
    />
    <path
      d="M17.4834 18.0358L16.1562 18.5749C16.982 18.6168 17.8013 18.683 18.6136 18.7726L17.4834 18.0358Z"
      fill="#003346"
    />
    <path
      d="M16.1566 18.5742L6.86426 22.3473L11.9418 28.5315C12.6132 28.6325 13.3002 28.6852 13.9994 28.6852C18.5727 28.6852 22.6239 26.4519 25.1246 23.0173L18.6139 18.7734C17.8017 18.683 16.9823 18.6169 16.1566 18.5742Z"
      fill="#006991"
    />
    <path
      d="M14 28.9333C6.28023 28.9333 0 22.6531 0 14.9333C0 7.21357 6.28023 0.93335 14 0.93335C21.7198 0.93335 28 7.21357 28 14.9333C28 22.6531 21.7198 28.9333 14 28.9333ZM14 1.43122C6.55477 1.43122 0.497866 7.4881 0.497866 14.9333C0.497866 22.3786 6.55476 28.4362 14.0007 28.4362C21.4467 28.4362 27.5028 22.3786 27.5028 14.9333C27.5028 7.4881 21.4452 1.43122 14 1.43122Z"
      fill="#007FA4"
    />
    <path
      d="M13.9995 5.63843C13.9995 5.63843 9.24137 10.0047 6.82031 12.2259V12.6619C9.48532 10.216 13.9981 6.07513 13.9981 6.07513L15.2129 7.18964C13.3431 8.90514 9.37366 12.5481 6.82102 14.8909V22.2409C6.82102 22.3568 6.91491 22.45 7.03013 22.45H10.794V18.6427H17.2051V22.45H20.969C21.0849 22.45 21.1781 22.3561 21.1781 22.2409V12.2259L13.9995 5.63843Z"
      fill="#CADB2E"
    />
    <path
      d="M13.9981 6.07556C13.9981 6.07556 9.48603 10.2164 6.82031 12.6623V14.8914C9.37366 12.5485 13.3424 8.90629 15.2122 7.19007L13.9981 6.07556Z"
      fill="#A2BA1B"
    />
    <path
      d="M17.205 22.4504H10.7939V17.0159C10.7939 15.2456 12.2292 13.8103 13.9995 13.8103C15.7698 13.8103 17.205 15.2456 17.205 17.0159V22.4504Z"
      fill="#05495F"
    />
    <path
      d="M17.205 19.8459H10.7939V17.0159C10.7939 15.2456 12.2292 13.8103 13.9995 13.8103C15.7698 13.8103 17.205 15.2456 17.205 17.0159V19.8459Z"
      fill="#003E51"
    />
    <path
      d="M22.4043 14.417L13.9996 6.70363L5.59494 14.417C5.48114 14.5216 5.30476 14.5137 5.20021 14.3999L4.516 13.6538C4.41144 13.54 4.41927 13.3637 4.53306 13.2591L13.8112 4.74488C13.9178 4.64673 14.0821 4.64673 14.1888 4.74488L23.4662 13.2591C23.58 13.3637 23.5871 13.54 23.4833 13.6538L22.7991 14.3999C22.6945 14.513 22.5181 14.5208 22.4043 14.417Z"
      fill="#007FA4"
    />
    <path
      d="M16.3798 11.2683C16.4794 11.141 16.5356 10.9789 16.5264 10.8025C16.5072 10.4355 16.1942 10.1424 15.8265 10.1453C15.5356 10.1481 15.2874 10.3288 15.1864 10.5841C15.1864 10.5848 15.1857 10.5855 15.1857 10.587C15.1053 10.8018 14.9062 10.9483 14.6771 10.9483H14.0015H13.3258C13.0968 10.9483 12.8976 10.801 12.8173 10.587C12.8173 10.5863 12.8165 10.5855 12.8165 10.5848C12.7155 10.3295 12.4673 10.1481 12.1764 10.146C11.8087 10.1432 11.4958 10.4362 11.4766 10.8032C11.4673 10.9789 11.5235 11.1417 11.6231 11.2683C11.7454 11.4248 11.7454 11.646 11.6231 11.8025C11.5235 11.9298 11.4673 12.0919 11.4766 12.2683C11.4958 12.6353 11.8087 12.9284 12.1764 12.9255C12.4673 12.9227 12.7155 12.742 12.8165 12.4867C12.8165 12.486 12.8173 12.4853 12.8173 12.4838C12.8976 12.269 13.0968 12.1225 13.3258 12.1225H14.0015H14.6771C14.9062 12.1225 15.1053 12.2698 15.1857 12.4838C15.1857 12.4845 15.1864 12.4853 15.1864 12.486C15.2874 12.7413 15.5356 12.9227 15.8265 12.9248C16.1942 12.9276 16.5072 12.6346 16.5264 12.2676C16.5356 12.0919 16.4794 11.9291 16.3798 11.8025C16.2575 11.646 16.2575 11.4248 16.3798 11.2683Z"
      fill="white"
    />
    <path
      d="M21.3186 9.58949C21.4336 9.58949 21.5269 9.49624 21.5269 9.38123C21.5269 9.26623 21.4336 9.17297 21.3186 9.17297C21.2036 9.17297 21.1104 9.26623 21.1104 9.38123C21.1104 9.49624 21.2036 9.58949 21.3186 9.58949Z"
      fill="#81C9DE"
    />
    <path
      d="M24.9973 10.5618C25.1123 10.5618 25.2056 10.4685 25.2056 10.3535C25.2056 10.2385 25.1123 10.1453 24.9973 10.1453C24.8823 10.1453 24.7891 10.2385 24.7891 10.3535C24.7891 10.4685 24.8823 10.5618 24.9973 10.5618Z"
      fill="#81C9DE"
    />
    <path
      d="M1.70435 14.8371C1.81937 14.8371 1.91261 14.7438 1.91261 14.6288C1.91261 14.5138 1.81937 14.4205 1.70435 14.4205C1.58933 14.4205 1.49609 14.5138 1.49609 14.6288C1.49609 14.7438 1.58933 14.8371 1.70435 14.8371Z"
      fill="#81C9DE"
    />
    <path
      d="M4.44166 10.1458C4.55666 10.1458 4.64992 10.0525 4.64992 9.93751C4.64992 9.8225 4.55666 9.72925 4.44166 9.72925C4.32665 9.72925 4.2334 9.8225 4.2334 9.93751C4.2334 10.0525 4.32665 10.1458 4.44166 10.1458Z"
      fill="#81C9DE"
    />
    <path
      d="M11.0022 5.10451C11.1172 5.10451 11.2105 5.01125 11.2105 4.89625C11.2105 4.78124 11.1172 4.68799 11.0022 4.68799C10.8872 4.68799 10.7939 4.78124 10.7939 4.89625C10.7939 5.01125 10.8872 5.10451 11.0022 5.10451Z"
      fill="#81C9DE"
    />
    <path
      d="M15.4924 3.256C15.6074 3.256 15.7007 3.16276 15.7007 3.04774C15.7007 2.93272 15.6074 2.83948 15.4924 2.83948C15.3774 2.83948 15.2842 2.93272 15.2842 3.04774C15.2842 3.16276 15.3774 3.256 15.4924 3.256Z"
      fill="#81C9DE"
    />
    <path
      d="M3.90258 17.7744C4.0667 17.7744 4.19968 17.6414 4.19968 17.4773C4.19968 17.3132 4.0667 17.1802 3.90258 17.1802C3.73846 17.1802 3.60547 17.3132 3.60547 17.4773C3.60547 17.6414 3.73846 17.7744 3.90258 17.7744Z"
      fill="#81C9DE"
    />
    <path
      d="M19.438 5.76639C19.668 5.76639 19.8545 5.57995 19.8545 5.34987C19.8545 5.11986 19.668 4.93335 19.438 4.93335C19.208 4.93335 19.0215 5.11986 19.0215 5.34987C19.0215 5.57995 19.208 5.76639 19.438 5.76639Z"
      fill="#81C9DE"
    />
    <path
      d="M24.2851 17.2373C24.4813 17.2373 24.6405 17.0782 24.6405 16.8819C24.6405 16.6856 24.4813 16.5265 24.2851 16.5265C24.0888 16.5265 23.9297 16.6856 23.9297 16.8819C23.9297 17.0782 24.0888 17.2373 24.2851 17.2373Z"
      fill="#81C9DE"
    />
    <path
      d="M6.82023 6.70456C7.01648 6.70456 7.17563 6.54541 7.17563 6.34917C7.17563 6.15292 7.01648 5.99377 6.82023 5.99377C6.62399 5.99377 6.46484 6.15292 6.46484 6.34917C6.46484 6.54541 6.62399 6.70456 6.82023 6.70456Z"
      fill="#81C9DE"
    />
    <path
      d="M17.7175 23.3615C17.8562 23.7015 17.6478 24.0834 17.2865 24.1503C16.5781 24.2825 15.3868 24.4547 13.9999 24.4547C12.613 24.4547 11.4216 24.2818 10.7132 24.1503C10.3519 24.0827 10.1443 23.7015 10.2822 23.3615L10.9487 21.7264C11.0248 21.5386 11.2076 21.4163 11.4095 21.4163H16.5888C16.7915 21.4163 16.9736 21.5386 17.0497 21.7264L17.7175 23.3615Z"
      fill="#EF6A3F"
    />
    <path
      d="M16.225 21.0671C16.1411 21.0671 16.0643 21.0962 16.0038 21.1446C15.974 20.9355 15.794 20.774 15.5764 20.774C15.432 20.774 15.3047 20.8452 15.2265 20.9533C15.1767 20.7698 15.0095 20.6346 14.8097 20.6346C14.6575 20.6346 14.5245 20.7129 14.4477 20.8316C14.3822 20.6474 14.2066 20.5151 14.0003 20.5151C13.794 20.5151 13.6184 20.6474 13.5529 20.8316C13.4761 20.7129 13.3424 20.6346 13.1909 20.6346C12.9918 20.6346 12.8246 20.7698 12.7741 20.9533C12.6959 20.8444 12.5686 20.774 12.4242 20.774C12.2066 20.774 12.0273 20.9348 11.9967 21.1446C11.9363 21.0962 11.8595 21.0671 11.7755 21.0671C11.5792 21.0671 11.4199 21.2264 11.4199 21.4227C11.4199 21.619 11.5792 21.7783 11.7755 21.7783C11.858 21.7783 12.9292 21.8907 14.0003 21.8907C15.0714 21.8907 16.1425 21.7783 16.225 21.7783C16.4213 21.7783 16.5807 21.619 16.5807 21.4227C16.5814 21.2264 16.4221 21.0671 16.225 21.0671Z"
      fill="white"
    />
  </svg>
);
